var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgetsData.length > 0)?_c('div',_vm._l((_vm.widgetsData),function(widget){return _c('div',{key:widget.selector},[_c('button-primary-forward',{key:widget.selector,class:widget.selector,attrs:{"text":widget.label},on:{"click":function($event){return _vm.triggerAccounceKit(widget)}}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }